<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">

          <!-- Título da tela -->
          <basic-toolbar :title="(this.projeto.situacao.item === 18 || this.projeto.situacao.item === 3) ? 'Suspender Ação de Extensão' : 'Prorrogar suspensão da ação de extensão'"></basic-toolbar>

          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
              <v-container>

                <!-- Dialog de confirmação -->
                <v-dialog v-model="dialog" width="550">
                  <v-card>
                    <v-card-title class="headline grey lighten-2" primary-title>
                      {{ (this.projeto.situacao.item === 18 || this.projeto.situacao.item === 3) ? 'Confirma a suspensão da ação de extensão?' : 'Confirma a prorrogação da suspensão da ação de extensão?' }}
                    </v-card-title>
                    <v-card-text>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-btn color="primary" text @click="dialog = false">Não</v-btn>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" text @click="suspenderProrrogarAcaoExtensao()">Sim</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <!-- Título -->
                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <v-text-field readonly label="Título" :value="this.projeto.titulo"></v-text-field>
                  </v-flex>
                </v-layout>

                <!-- Número e situação -->
                <v-layout row wrap justify-space-between>

                  <!-- Número -->
                  <v-flex xs6>
                    <v-text-field readonly label="Número" :value="this.projeto.idProjeto"></v-text-field>
                  </v-flex>

                  <!-- Situação -->
                  <v-flex xs6>
                    <v-text-field readonly label="Situação" :value="this.projeto.situacao.descricao"></v-text-field>
                  </v-flex>

                </v-layout>

                <!-- Data de início e Data de conclusão da ação de extensão -->
                <v-layout row wrap justify-space-between>

                  <!-- Data de início da ação de extensão -->
                  <v-flex xs6>
                    <v-text-field readonly label="Data de início da ação de extensão" :value="dates.format(this.projeto.dataInicio)"></v-text-field>
                  </v-flex>

                  <!-- Data de conclusão da ação de extensão -->
                  <v-flex xs6>
                    <v-text-field readonly label="Data de conclusão da ação de extensão" :value="dates.format(this.projeto.dataConclusao)"></v-text-field>
                  </v-flex>

                </v-layout>

                <!-- Coordenador -->
                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <v-text-field readonly label="Coordenador" :value="this.projeto.nomeCoordenador"></v-text-field>
                  </v-flex>
                </v-layout>

                <!-- Suspensões -->
                <v-layout row wrap justify-space-between v-if="this.projeto.situacao.item === 4">
                  <v-flex xs12>
                    <label class="labelSuspensoes">Suspensões</label>
                  </v-flex>
                  <v-flex xs12>
                    <v-data-table v-if="listaSuspensoes.length !== 0"
                      class="elevation-1 suspensoes"
                      :headers="headersSuspensoes"
                      :header-props="{ sortIcon: null }"
                      :items="listaSuspensoes"
                      :items-per-page="-1"
                      hide-default-footer
                    >
                      <!-- Formata data de início da suspensão -->
                      <template v-slot:item.dtInicioSuspensao="props">{{dates.format(props.item.dtInicioSuspensao)}}</template>

                      <!-- Formata data de fim da suspensão -->
                      <template v-slot:item.dtFimSuspensao="props">{{dates.format(props.item.dtFimSuspensao)}}</template>

                    </v-data-table>
                  </v-flex>
                </v-layout>

                <!-- Processo -->
                <v-layout row wrap justify-space-between>
                  <v-flex xs5>
                    <v-text-field
                      label="Processo*"
                      v-model="suspensao.processo"
                      :rules="obrigatorio"
                      prepend-icon="feed"
                      >
                    </v-text-field>
                  </v-flex>
                </v-layout>

                <!-- Período da suspensão -->
                <v-layout row wrap justify-space-between>

                  <!-- Data de início da suspensão -->
                  <v-flex xs5>
                    <c-date-dialog
                      :label="(this.projeto.situacao.item === 18 || this.projeto.situacao.item === 3) ? 'Data de início da suspensão*' : 'Data de início da nova suspensão*'"
                      v-model="suspensao.dtInicioSuspensao"
                      :rules="obrigatorio"
                    >
                    </c-date-dialog>
                  </v-flex>

                  <v-spacer></v-spacer>

                  <!-- Data de fim da suspensão -->
                  <v-flex xs5>
                    <c-date-dialog
                      :label="(this.projeto.situacao.item === 18 || this.projeto.situacao.item === 3) ? 'Data de fim da suspensão*' : 'Data de fim da nova suspensão*'"
                      v-model="suspensao.dtFimSuspensao"
                      :rules="obrigatorio"
                    >
                    </c-date-dialog>
                  </v-flex>

                </v-layout>

                <!-- Justificativa/Observação -->
                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <c-textarea
                      label="Justificativa/Observação"
                      v-model="suspensao.justificativaObservacao"
                      :rules="tamanho2000caracteres"
                      :rows="3"
                      :auto-grow="true"
                      multi-line
                      counter="2000"
                      required
                     >
                    </c-textarea>
                  </v-flex>
                </v-layout>

                <p class="mt-3"></p>

              </v-container>
            </v-form>

            <v-divider></v-divider>

            <!-- Botões "Cancelar" e "Suspender / Prorrogar" -->
            <v-card-actions>

              <!-- Cancelar -->
              <v-btn color="primary" text @click="cancelar">Cancelar</v-btn>

              <v-spacer></v-spacer>

              <!-- Suspender / Prorrogar -->
              <v-btn color="primary" text @click="dialog = true" :disabled="!formularioValido">
                {{ (this.projeto.situacao.item === 18 || this.projeto.situacao.item === 3) ? 'Suspender' : 'Prorrogar' }}
              </v-btn>

            </v-card-actions>

          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import TextArea from '@/components/c-textarea'
  import DataDialog from '@/components/c-date-dialog'
  import dates from '@/utils/dates'
  import projetos from '@/utils/projetos'
  import { mapActions } from 'vuex'

  export default {
    props: ['idProjeto'],
    data: () => ({
      dialog: false,
      dates: dates,
      listaSuspensoes: [],
      headersSuspensoes: [
        { text: 'Início', align: 'left', value: 'dtInicioSuspensao' },
        { text: 'Fim', align: 'left', value: 'dtFimSuspensao' },
        { text: 'Processo', left: 'left', value: 'processo' }
      ],
      formularioValido: false,
      projeto: {
        situacao: {},
        tipoPublico: {},
        classificacoesPrimariaSecundaria: [{}, {}]
      },
      suspensao: {
        processo: '',
        dtInicioSuspensao: '',
        dtFimSuspensao: '',
        justificativaObservacao: ''
      },
      obrigatorio: [
        (input) => !!input || 'Este campo é obrigatório'
      ],
      tamanho2000caracteres: [
        (input) => input.length <= 2000 || 'Este campo não pode possuir mais que 2000 caracteres'
      ]
    }),
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      // Cancelar.
      cancelar: function () {
        this.$router.go(-1)
      },
      // Suspender ou prorrogar.
      suspenderProrrogarAcaoExtensao: function () {
        if (this.projeto.situacao.item === 18 || this.projeto.situacao.item === 3) {
          this.suspenderAcaoExtensao()
        } else {
          this.prorrogarSuspensaoAcaoExtensao()
        }
      },
      // Suspender ação de extensão.
      suspenderAcaoExtensao: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Suspendendo ação de extensão...' })
        projetos.postSuspenderAcaoExtensao(this.idProjeto, this.suspensao)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          this.$router.go(-1)
        })
        .catch(error => {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Suspendendo ação de extensão...' })
        })
      },
      // Prorrogar suspensão da ação de extensão.
      prorrogarSuspensaoAcaoExtensao: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Prorrogando suspensão da ação de extensão...' })
        projetos.postProrrogarSuspensaoAcaoExtensao(this.idProjeto, this.suspensao)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          this.$router.go(-1)
        })
        .catch(error => {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Prorrogando suspensão da ação de extensão...' })
        })
      }
    },
    mounted () {
      // Carrega ação de extensão.
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ação de extensão...' })
      projetos.getProjeto(this.idProjeto)
      .then(response => {
        this.projeto = response.data
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ação de extensão...' })
      })

      // Carrega as suspensões de uma ação de extensão.
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando suspensões...' })
      projetos.getSuspensoes(this.idProjeto)
      .then(response => {
        this.listaSuspensoes = response.data
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando suspensões...' })
      })
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'c-date-dialog': DataDialog,
      'c-textarea': TextArea
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  .no-resize div textarea{
    resize: none;
  }

  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>

<style scoped>

  .labelSuspensoes {
    font-size: 0.9em;
  }

  .suspensoes {
    margin-top: 1em;
    margin-bottom: 1em;
  }

</style>



// WEBPACK FOOTER //
// suspender-acao-extensao.vue?cff75bbe